var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, centerScreen: "", maxWidth: "640px" },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("Title", {
                staticClass: "mb-4",
                attrs: { title: _vm.modalTitle, underlined: "" }
              })
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "d-flex align-center mt-4 justify-end" },
                [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: _vm.dismiss } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.step === "empty" ? "Fechar" : "Dispensar"
                          ) +
                          " "
                      )
                    ]
                  ),
                  _vm.step === "empty" && _vm.isGestor
                    ? _c(
                        "BaseButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.goToTriggerSettings }
                        },
                        [_vm._v(" Configurar templates ")]
                      )
                    : _vm.step === "picker"
                    ? _c(
                        "BaseButton",
                        {
                          attrs: {
                            primary: "",
                            disabled: !_vm.canContinueFromPicker
                          },
                          on: { click: _vm.confirmPicker }
                        },
                        [_vm._v(" Continuar ")]
                      )
                    : _vm.step === "wizard"
                    ? _c(
                        "BaseButton",
                        {
                          attrs: {
                            primary: "",
                            loading: _vm.loading,
                            disabled: !_vm.canSubmit
                          },
                          on: { click: _vm.submit }
                        },
                        [_vm._v(" Criar task ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "trigger-suggester-modal pa-6" }, [
        _vm.step === "empty"
          ? _c("div", [
              _vm.isGestor
                ? _c(
                    "div",
                    { staticClass: "text-center py-4" },
                    [
                      _c("icon-svg", {
                        staticClass: "mb-3",
                        attrs: {
                          name: "mdi-lightning-bolt-outline",
                          size: 48,
                          color: "var(--secondary)"
                        }
                      }),
                      _c(
                        "p",
                        { staticClass: "az-text-body text-color-700 mb-2" },
                        [
                          _vm._v(
                            " Nenhum template de task configurado para leads ganhos. "
                          )
                        ]
                      ),
                      _c(
                        "p",
                        { staticClass: "az-text-small text-color-500 mb-0" },
                        [
                          _vm._v(
                            " Crie um template de task e vincule ao evento "
                          ),
                          _c("strong", [_vm._v("Lead ganho no CRM")]),
                          _vm._v(
                            " em Tarefas › Configurações › Triggers. Assim, toda vez que um lead for ganho, esta sugestão aparece preenchida automaticamente. "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "text-center py-4" },
                    [
                      _c("icon-svg", {
                        staticClass: "mb-3",
                        attrs: {
                          name: "mdi-lightning-bolt-outline",
                          size: 48,
                          color: "var(--secondary)"
                        }
                      }),
                      _c(
                        "p",
                        { staticClass: "az-text-body text-color-700 mb-2" },
                        [
                          _vm._v(
                            " Nenhum template de task configurado para este evento. "
                          )
                        ]
                      ),
                      _c(
                        "p",
                        { staticClass: "az-text-small text-color-500 mb-0" },
                        [
                          _vm._v(
                            " Fale com o gestor do escritório para configurar templates de tasks automáticas ao ganhar leads no CRM. "
                          )
                        ]
                      )
                    ],
                    1
                  )
            ])
          : _vm.step === "picker"
          ? _c(
              "div",
              [
                _c("p", { staticClass: "az-text-small text-color-600 mb-4" }, [
                  _vm._v(
                    " Existem múltiplos templates configurados para este evento. Escolha qual deseja usar: "
                  )
                ]),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-0 pt-0",
                    attrs: { "hide-details": "" },
                    model: {
                      value: _vm.selectedMappingId,
                      callback: function($$v) {
                        _vm.selectedMappingId = $$v
                      },
                      expression: "selectedMappingId"
                    }
                  },
                  _vm._l(_vm.pickerOptions, function(opt) {
                    return _c("v-radio", {
                      key: opt.id,
                      staticClass: "mb-2",
                      attrs: { value: opt.id, label: opt.title }
                    })
                  }),
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "mb-4" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "az-text-label text-color-700 mb-1 d-block"
                      },
                      [_vm._v("Título da task")]
                    ),
                    _c("InputByType", {
                      attrs: {
                        type: "text",
                        placeholder: "Ex.: Onboarding João Silva",
                        dense: "",
                        outlined: ""
                      },
                      model: {
                        value: _vm.form.title,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "title", $$v)
                        },
                        expression: "form.title"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "az-text-label text-color-700 mb-1 d-block"
                          },
                          [_vm._v("Responsável principal")]
                        ),
                        _c("TaskAssigneePicker", {
                          attrs: {
                            value: _vm.form.responsavelPrincipal,
                            mode: "single",
                            placeholder: "Selecionar responsável"
                          },
                          on: { input: _vm.onResponsavelInput }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "az-text-label text-color-700 mb-1 d-block"
                          },
                          [_vm._v("Participantes")]
                        ),
                        _c("TaskAssigneePicker", {
                          attrs: {
                            value: _vm.form.participantes,
                            mode: "multi",
                            placeholder: "Selecionar participantes"
                          },
                          on: { input: _vm.onParticipantesInput }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "az-text-label text-color-700 mb-1 d-block"
                      },
                      [_vm._v("Cliente")]
                    ),
                    _c("TaskClientPicker", {
                      attrs: {
                        value: _vm.form.cliente,
                        placeholder: "Vincular cliente"
                      },
                      on: { input: _vm.onClienteInput }
                    })
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticClass: "mt-4", attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "az-text-label text-color-700 mb-1 d-block"
                          },
                          [_vm._v("Data base")]
                        ),
                        _c("InputByType", {
                          attrs: {
                            type: "date",
                            placeholder: "Selecionar data base",
                            dense: "",
                            outlined: ""
                          },
                          model: {
                            value: _vm.form.baseDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "baseDate", $$v)
                            },
                            expression: "form.baseDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "az-text-label text-color-700 mb-1 d-block"
                          },
                          [_vm._v("Pasta")]
                        ),
                        _c("v-select", {
                          attrs: {
                            items: _vm.folderOptions,
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            clearable: "",
                            placeholder: "Pasta",
                            loading: _vm.loadingFolders,
                            disabled: _vm.loadingFolders,
                            "menu-props": { offsetY: true }
                          },
                          model: {
                            value: _vm.form.folderId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "folderId", $$v)
                            },
                            expression: "form.folderId"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "az-text-label text-color-700 mb-1 d-block"
                          },
                          [_vm._v("Sprint")]
                        ),
                        _c("v-select", {
                          attrs: {
                            items: _vm.sprintOptions,
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            clearable: "",
                            disabled: _vm.loadingFolders || !_vm.form.folderId,
                            placeholder: "Sprint",
                            "menu-props": { offsetY: true }
                          },
                          model: {
                            value: _vm.form.sprintId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "sprintId", $$v)
                            },
                            expression: "form.sprintId"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }